import { createAxiosConfig, creditAxiosApi } from 'services/axiosApi';
import {
    DataprevMarginQueryUpdateModel,
    IDataprevMarginQueryReadModel,
    TFirstPaymentDateProps,
    TPostFirstPaymentDateProps,
    TUpdateDataprevProps
} from 'services/zetra';

const url = '/DataprevEmployee';

export async function postUpdateDataprevMarginQueryAsync(
    prop: TUpdateDataprevProps,
    token: string
) {
    const { personId, registrationNumber } = prop ?? {};
    const params = { registrationNumber, personId };
    const endpoint = `${url}/FreeMarginQuery`;
    const axiosConfig = createAxiosConfig(token, params);

    return await creditAxiosApi.post<DataprevMarginQueryUpdateModel>(endpoint, {}, axiosConfig);
}

export async function getDataprevMarginQueryAsync(params: TUpdateDataprevProps, token: string) {
    const endpoint = `${url}/FreeMarginQuery`;
    const axiosConfig = createAxiosConfig(token, params);
    return await creditAxiosApi.get<IDataprevMarginQueryReadModel[]>(endpoint, axiosConfig);
}

export async function postFirstPaymentDateAsync(token: string, prop?: TPostFirstPaymentDateProps) {
    const endpoint = `${url}/FirstPaymentDate`;
    const { startDate } = prop ?? {};
    const params = { startDate };
    const axiosConfig = createAxiosConfig(token, params);
    return await creditAxiosApi.post<TFirstPaymentDateProps>(endpoint, {}, axiosConfig);
}
